import { getOnlyElementByAttribute } from './getOnlyElementByAttribute';

export const checkShippingValidity = (requiresShipping: boolean) => {
  const shippingAddressForm = getOnlyElementByAttribute(
    '[data-node-type="commerce-checkout-shipping-address-wrapper"]'
  ) as HTMLInputElement;

  const shippingAddressFormClassList = shippingAddressForm.classList;

  let shippingFormVisible = true;

  shippingAddressFormClassList.forEach((className) => {
    if (className === 'w-condition-invisible') {
      shippingFormVisible = false;
    }
  });

  const shippingValid = !shippingFormVisible && requiresShipping ? false : true;

  return { shippingValid };
};
